// extracted by mini-css-extract-plugin
export var RakuuruHeader = "RakuuruHeader-module--RakuuruHeader--2Ve_T";